import { observer } from 'mobx-react-lite';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StatBox } from '@feathr/components';

import type { IStatProps } from './Stats';

interface IProps extends IStatProps {
  isLoading?: boolean;
  isMonetization?: boolean;
  totalUsers?: number;
}

interface IPropsSmall extends IStatProps {
  isLoading?: boolean;
  isMonetization?: never;
  size: 'mini';
  totalUsers?: never;
}

function ReachStat({
  isLoading,
  isMonetization,
  label,
  size = 'default',
  tooltip,
  totalUsers,
  value,
}: IPropsSmall | IProps): JSX.Element {
  const { t } = useTranslation();
  const formatted = numeral(value).format('0,0');
  const translatedTooltip =
    tooltip ??
    t(
      'Reach counts unique people who viewed your ads. Reach % shows this against your current audience size, which updates as your audience changes.',
    );
  const translatedLabel = label ?? t('Reach');

  const percent =
    !isMonetization && totalUsers
      ? value
        ? numeral(Math.min(value / totalUsers, 1))
        : 0
      : undefined;

  const secondary = percent ? `${percent.format('0.00%')} of Target` : undefined;

  return (
    <StatBox
      isLoading={isLoading}
      label={translatedLabel}
      primary={formatted}
      secondary={secondary}
      size={size}
      tooltip={translatedTooltip}
    />
  );
}

export default observer(ReachStat);
